<template>
  <SideMenuLayout title="Marketing" :items="items">
    <slot/>
  </SideMenuLayout>
</template>

<script>
import SideMenuLayout from "@/components/SideMenuLayout.vue";

const ITEMS = [
  {to: '/marketing', label: 'Contenus', icon: 'list'},
  {to: '/marketing-publications', label: 'Publications', icon: 'outgoing'},
  {to: '/marketing-performance', label: 'Performance', icon: 'chart'},
  {to: '/marketing-connections', label: 'Connexions', icon: 'link'},
  {to: '/marketing-settings', label: 'Réglages', icon: 'sliders'},
];

/**
 * Menu latéral du marketing ; le contenu de la page se place à l'intérieur.
 * Contenus : concevoir et préparer. Publications : diffuser et mesurer. Connexions : relier les comptes des réseaux et en importer les publications.
 */
export default {
  name: "MarketingHeader",
  components: {SideMenuLayout},
  data() {
    return {items: ITEMS};
  },
};
</script>
